import { OnBoardingBusinessInformationIsBusinessOwnerProps } from '@/types/props/components/onboarding';
import { OnboardingEnum } from '@/types/translations/OnboardingEnum';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import SpiritoryCheckbox from '@/components/common/Forms/SpiritoryCheckbox';
export default function OnBoardingBusinessInformationIsBusinessOwner({
  isBusinessOwner,
  setIsBusinessOwner,
}: OnBoardingBusinessInformationIsBusinessOwnerProps) {
  const { translate } = useTypedTranslation<OnboardingEnum>('onboarding');

  return (
    <div className="tw-w-[60vw] tw-min-w-56">
      <h2 className="tw-font-plusJakartaSans tw-font-bold tw-text-2xl tw-leading-[30.24px] tw-text-text max-nine:!tw-text-lg">
        {translate(
          OnboardingEnum['business_information.are_you_a_business_owner']
        )}
      </h2>

      <div className="tw-pt-5 tw-flex tw-flex-col tw-gap-3">
        <SpiritoryCheckbox
          label={translate(
            OnboardingEnum['business_information.yes_i_am_a_business_owner']
          )}
          checked={isBusinessOwner}
          onChange={() => setIsBusinessOwner(true)}
          squared={false}
          weight="bold"
          color="black"
          size="big"
        />
        <SpiritoryCheckbox
          label={translate(
            OnboardingEnum['business_information.no_i_am_not_a_business_owner']
          )}
          checked={!isBusinessOwner}
          onChange={() => setIsBusinessOwner(false)}
          squared={false}
          weight="bold"
          color="black"
          size="big"
        />
      </div>
    </div>
  );
}
